import React from "react";
import Contactus from "../components/Contactus";
import ContactDetails from "../components/ContactDetails";


const ContactUs = () => {
  return (
    <>
      <ContactDetails/>
      <Contactus/>
    </>
  );
};

export default ContactUs;
